export const GET_NEWS = 'GET_NEWS';
